<div class="holder">
  <span class="title">{{'Waiting for further quotes...' | translate}}</span>
  <span class="subtitle">{{'You will receive a notification when new quotes arrive' | translate}}</span>
</div>